import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import Hero from '../components/hero'
import AboutCompany from '../components/about-company'
import AboutMe from '../components/about'
import Projects from '../components/projects'
import Services from '../components/services'
import TechDeepDive from '../components/tech-deep-dive'
import Contact from '../components/contact'

import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Stefan Lacher | Software Solutions for Web, Apps & Data</title>
        <meta
          name="description"
          content="I create tailored software solutions for Web, Mobile and Data — from modern websites to scalable cloud systems. Based in Austria, working globally."
        />
        <meta
          property="og:title"
          content="Stefan Lacher | Software Solutions for Web, Apps &amp; Data"
        />
        <meta
          property="og:description"
          content="I create tailored software solutions for Web, Mobile and Data — from modern websites to scalable cloud systems. Based in Austria, working globally."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/50551946-307e-48ab-899a-950ab7a25dad/b42c331b-8e8e-4f35-9121-338a7598a0a4?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <Header
        textAbout={
          <Fragment>
            <span className="home-page-text10">About</span>
          </Fragment>
        }
        textContact={
          <Fragment>
            <span className="home-page-text11">Contact</span>
          </Fragment>
        }
        textProjects={
          <Fragment>
            <span className="home-page-text12">Projects</span>
          </Fragment>
        }
        textServices={
          <Fragment>
            <span className="home-page-text13">Services</span>
          </Fragment>
        }
        textAboutMobile={
          <Fragment>
            <span className="home-page-text14">About</span>
          </Fragment>
        }
        textContactMobile={
          <Fragment>
            <span className="home-page-text15">Contact</span>
          </Fragment>
        }
        textProjectsMobile={
          <Fragment>
            <span className="home-page-text16">Projects</span>
          </Fragment>
        }
        textServicesMobile={
          <Fragment>
            <span className="home-page-text17">Services</span>
          </Fragment>
        }
      ></Header>
      <Hero></Hero>
      <AboutCompany></AboutCompany>
      <AboutMe></AboutMe>
      <Projects></Projects>
      <Services></Services>
      <TechDeepDive></TechDeepDive>
      <Contact></Contact>
      <Footer
        textMade={
          <Fragment>
            <span className="home-page-text47">Made with</span>
          </Fragment>
        }
        textName={
          <Fragment>
            <span className="home-page-text48">Stefan Lacher</span>
          </Fragment>
        }
        textYear={
          <Fragment>
            <span className="home-page-text49">© 2025</span>
          </Fragment>
        }
        textContact={
          <Fragment>
            <span className="home-page-text50">Contact</span>
          </Fragment>
        }
        textImpressum={
          <Fragment>
            <span className="home-page-text51">Impressum</span>
          </Fragment>
        }
        textPrivacyPolicy={
          <Fragment>
            <span className="home-page-text52">Privacy Policy</span>
          </Fragment>
        }
      ></Footer>
    </div>
  )
}

export default Home
